import {useDebugValue} from 'react';

import {getNoUndefValuesObject} from '../../../utils/object';

function useOptions(defaultOptions, ...otherOptions) {
    const specifiedOptions = otherOptions.reduce((accumulatedOptions, currentOptions) => ({
        ...accumulatedOptions,
        ...getNoUndefValuesObject(currentOptions)
    }), {});

    const options = {
        ...defaultOptions,
        ...specifiedOptions
    };

    const result = {
        options
    };

    useDebugValue(result);

    return result;
}

export {useOptions};
